function roundNumber(number: number, decimals: number = 2) {

	return parseFloat(Number(`${number}`).toFixed(parseInt(decimals.toString(), 10)));

}

export default roundNumber;
